import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { Table, Modal, ModalHeader, ModalBody } from 'reactstrap';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import AddIcon from '@mui/icons-material/AddRounded';
import Swal from "sweetalert2/dist/sweetalert2";
const AddonDetails = ({ isOpen, toggle, AddonDetails , individualCosts, planId, additionalCOACost , planCost, planCOICost, currentCover, removeAddon , handleAddonSelect }) => {
    console.log(AddonDetails, 'AddonDetails')
    console.log(planCost, 'planCost')
    const [liveAddonDetails, setLiveAddonDetails] = useState(Array.isArray(AddonDetails) ? AddonDetails : []);

    useEffect(() => {
        setLiveAddonDetails(Array.isArray(AddonDetails) ? AddonDetails : []);
    }, [AddonDetails, isOpen]);

     const truncateLabel = (label, limit) => {
        if (label.length > limit) {
            return label.slice(0, limit) + "...";
        }
        return label;
    };

    const getAddonUnitCost = (item) => {
        const serviceAddonCosts = individualCosts || {};
        const key = `${item.value}+${item.add_on_type?.toLowerCase()}`;
        const storedCost = Number(serviceAddonCosts[key]?.addonCost || 0);

        if (storedCost > 0) {
            return storedCost;
        }

        const addonValueType = String(item?.addon_value_type || '').toLowerCase();
        const addonCoaValue = Number(item?.addon_coa_value || 0);

        if (addonValueType === 'fixed') {
            return addonCoaValue;
        }

        return (Number(planCost || 0) * addonCoaValue) / 100;
    };

      const handleDeletePlan = async (item) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You want to delete this addon!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });
    
        if (result.isConfirmed) {
            setLiveAddonDetails((prev) => {
                const indexToRemove = prev.findIndex(
                    (addon) => addon.value === item.value && addon.add_on_type === item.add_on_type
                );

                if (indexToRemove === -1) {
                    return prev;
                }

                const next = [...prev];
                next.splice(indexToRemove, 1);
                return next;
            });
            removeAddon(item, planId, planCost);
        }
    };
      const handleAddonPlan = async (item) => {
       setLiveAddonDetails((prev) => ([...prev, item]));
       handleAddonSelect(item, planId, currentCover, planCost, planCOICost, item?.add_on_type?.toLowerCase?.());
        
    };

    const addonList = useMemo(() => {
        const groupedAddons = [];

        liveAddonDetails &&
        liveAddonDetails.length > 0 &&
        liveAddonDetails.forEach((item, index) => {
            const addonCost = getAddonUnitCost(item);

            const existingItem = groupedAddons.find(
                (addon) => addon.value === item.value && addon.add_on_type === item.add_on_type
            );

            if (existingItem) {
                existingItem.index.push(index);
                existingItem.count += 1;
            } else {
                groupedAddons.push({
                    value: item.value,
                    add_on_type: item.add_on_type,
                    label: item.label,
                    addon_coa_value: item.addon_coa_value,
                    addon_value_type: item.addon_value_type,
                    addonCost,
                    index: [index],
                    count: 1,
                });
            }
        });

        return groupedAddons;
    }, [liveAddonDetails, individualCosts, planCost]);

    const liveAdditionalCOACost = useMemo(() => {
        if (!addonList.length) {
            return 0;
        }

        return addonList.reduce((total, item) => total + (Number(item.addonCost || 0) * Number(item.count || 0)), 0);
    }, [addonList]);


    return (
        <Fragment>
            <Modal isOpen={isOpen} toggle={toggle} backdrop="static" style={{ maxWidth: "700px" }}>
                <ModalHeader toggle={toggle} style={{ borderBottom: "none", paddingBottom: "0px" }}>Addon Details</ModalHeader>
                <ModalBody>
                    <>  
                       <div key={"total_addon_cost"} style={{ display: "flex", justifyContent: "space-between"}}>
                            <div style={{ padding: "4px", textAlign: "left" }}>
                                <b>Plan Cost</b>
                            </div>
                            <div style={{ padding: "4px", textAlign: "right" , marginRight: "60px"}}>
                                {`₹${planCost} `}
                            </div>
                        </div>   
                          {addonList && addonList.length > 0 ? ( addonList.map((item, idx) => (
                              <div
                                key={idx}
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr auto 100px",
                                    alignItems: "center",
                                    borderTop: "1px solid #dee2e6",
                                    padding: "8px 0",
                                    marginTop: "10px",
                                }}
                                >
                                {/* Left Column: Label and Type */}
                                <div>
                                    <div>
                                    {`${truncateLabel(item.label, 15)} (${item?.addon_value_type !== "percentage" ? "₹" : ""}${item.addon_coa_value}${item?.addon_value_type === "percentage" ? "%" : ""}) x ${item.count}`}
                                    </div>
                                    <div style={{ fontSize: "12px", color: "#666" }}>{item.add_on_type}</div>
                                </div>

                                {/* Middle Column: Icons */}
                                <div style={{ display: "flex", gap: "8px", justifyContent: "center" , marginRight: "105px"}}>
                                    <div style={{ cursor: "pointer" }}>
                                    <AddIcon style={{ color: "green" }} onClick={() => handleAddonPlan(item)} />
                                    </div>
                                    <div style={{ cursor: "pointer" }}>
                                    <RemoveRoundedIcon style={{ color: "red" }} onClick={() => handleDeletePlan(item)} />
                                    </div>
                                </div>

                                {/* Right Column: Cost */}
                                <div style={{ textAlign: "left" }}>
                                    {`₹${(item.addonCost * item.count).toFixed(2)}`}
                                </div>
                                </div>

                            )) ) : (
                            <p>No addons available.</p>
                        )} 
                    </>
                        <div key={"total_addon_cost"} style={{ display: "flex", justifyContent: "space-between", borderTop: "1px solid #dee2e6", marginTop: "10px"}}>
                            <div style={{ padding: "4px", textAlign: "left" }}>
                                <b>Total Addon Cost (COA)</b>
                            </div>
                            <div style={{ padding: "4px", textAlign: "right" , marginRight: "41px"}}>
                                {`₹${liveAdditionalCOACost.toFixed(2)} `}
                            </div>
                        </div>    
                </ModalBody>
            </Modal>
        </Fragment>
    );
};

export default AddonDetails;